import React from 'react';
import { storeContext } from '../../context';
import RegistryForm from '../RegistryForm';
import { Col, Form, Input, Row, Select, Switch } from 'antd';
import { useObserver } from 'mobx-react';

const { Option } = Select;

const labelCol = {
  xs: 24,
  sm: 24,
  md: 12,
  lg: 12,
  xl: 10,
};

const columns = [
  {
    title: 'Bssid',
    dataIndex: 'bssid',
    key: 'bssid',
  },
  {
    title: 'Device Name',
    dataIndex: 'device_name',
    key: 'device_name',
  }
  ,
  {
    title: 'Device Eui',
    dataIndex: 'device_eui',
    key: 'device_eui',
  },
  {
    title: 'Latitulde',
    dataIndex: 'lat',
    key: 'lat',
  },
  {
    title: 'Longitude',
    dataIndex: 'lng',
    key: 'lng',
  },
  {
    title: 'Accuracy',
    dataIndex: 'accuracy',
    key: 'accuracy',
  },
  {
    title: 'Rssi',
    dataIndex: 'rssi',
    key: 'rssi',
  },
  {
    title: 'Reg Type',
    dataIndex: 'reg_type',
    key: 'reg_type',
  },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
  }
];

let ContentForm = () => {
  const store = React.useContext(storeContext);

  const handleChange = (field, event) => {
    store.currentItem[field] = event.target.value;
  }

  const handleSelect = (field, value) => {
    store.currentItem[field] = value;
  }
  const handleSwitchChange = (field, checked) => {
    store.currentItem[field] = checked ? 1 : 0;
  }

  const handleBssidChange = (event) => {
    let value = event.target.value;

    // Remove todos os caracteres não hexadecimais e converte para uppercase
    value = value.replace(/[^0-9A-Fa-f]/g, '').toUpperCase();

    // Limita a 12 caracteres
    value = value.substring(0, 12);

    // Adiciona dois pontos a cada 2 dígitos
    if (value.length > 0) {
      const formatted = value.match(/.{1,2}/g)?.join(':') || value;
      store.currentItem.bssid = formatted;
    } else {
      store.currentItem.bssid = '';
    }
  }

  const handleDeviceEuiChange = (event) => {
    let value = event.target.value;

    // Limita a 50 caracteres
    value = value.substring(0, 50);

    store.currentItem.device_eui = value;
  }

  const validateBssid = (value) => {
    if (!value) return true; // Campo vazio é válido (não obrigatório)

    // Remove os dois pontos para contar apenas os caracteres hexadecimais
    const hexOnly = value.replace(/:/g, '');
    return hexOnly.length === 12;
  }

  const validateDeviceEui = (value) => {
    if (!value) return true; // Campo vazio é válido (não obrigatório)

    return value.length <= 50;
  }

  const validateLatitude = (value) => {
    if (!value) return true; // Campo vazio é válido (não obrigatório)

    const lat = parseFloat(value);
    return !isNaN(lat) && lat >= -90 && lat <= 90;
  }

  const validateLongitude = (value) => {
    if (!value) return true; // Campo vazio é válido (não obrigatório)

    const lng = parseFloat(value);
    return !isNaN(lng) && lng >= -180 && lng <= 180;
  }

  const validateRssi = (value) => {
    if (!value) return true; // Campo vazio é válido (não obrigatório)

    const rssi = parseFloat(value);
    return !isNaN(rssi) && rssi >= -100 && rssi <= 0;
  }

  const validateAccuracy = (value) => {
    if (!value) return true; // Campo vazio é válido (não obrigatório)

    const accuracy = parseFloat(value);
    return !isNaN(accuracy) && accuracy >= 0;
  }

  const switchChecked = (value) => {
    return value && value !== '0' ? true : false;
  }

  return useObserver(() => (
    <Form layout="vertical">
      <Row gutter={16}>
        <Col {...labelCol}>
          <Form.Item
            label="Bssid"
            validateStatus={store.currentItem.bssid && !validateBssid(store.currentItem.bssid) ? 'error' : ''}
            help={store.currentItem.bssid && !validateBssid(store.currentItem.bssid) ? 'O BSSID deve ter exatamente 12 caracteres hexadecimais' : ''}
          >
            <Input
              value={store.currentItem.bssid}
              onChange={handleBssidChange}
              disabled={!!store.currentItem.id}
              placeholder="00:11:22:33:44:55 (12 caracteres hexadecimais)"
              maxLength={17}
            />
          </Form.Item>
        </Col>

      </Row>

      <Row gutter={16}>
        <Col {...labelCol}>
          <Form.Item label="Device Name">
            <Input
              value={store.currentItem.device_name}
              onChange={handleChange.bind(this, 'device_name')}
              placeholder="Nome do dispositivo"
            />
          </Form.Item>
        </Col>

        <Col {...labelCol}>
          <Form.Item
            label="Device Eui"
            validateStatus={store.currentItem.device_eui && !validateDeviceEui(store.currentItem.device_eui) ? 'error' : ''}
            help={store.currentItem.device_eui && !validateDeviceEui(store.currentItem.device_eui) ? 'O Device EUI deve ter no máximo 50 caracteres' : ''}
          >
            <Input
              value={store.currentItem.device_eui}
              onChange={handleDeviceEuiChange}
              placeholder="Digite o Device EUI (máximo 50 caracteres)"
              maxLength={50}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col {...labelCol}>
          <Form.Item
            label="Latitude"
            validateStatus={store.currentItem.lat && !validateLatitude(store.currentItem.lat) ? 'error' : ''}
            help={store.currentItem.lat && !validateLatitude(store.currentItem.lat) ? 'A latitude deve estar entre -90 e 90 graus' : ''}
          >
            <Input
              value={store.currentItem.lat}
              onChange={handleChange.bind(this, 'lat')}
              placeholder="-19.9325215"
            />
          </Form.Item>
        </Col>

        <Col {...labelCol}>
          <Form.Item
            label="Longitude"
            validateStatus={store.currentItem.lng && !validateLongitude(store.currentItem.lng) ? 'error' : ''}
            help={store.currentItem.lng && !validateLongitude(store.currentItem.lng) ? 'A longitude deve estar entre -180 e 180 graus' : ''}
          >
            <Input
              value={store.currentItem.lng}
              onChange={handleChange.bind(this, 'lng')}
              placeholder="-44.0656834"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col {...labelCol}>
          <Form.Item
            label="Accuracy"
            validateStatus={store.currentItem.accuracy && !validateAccuracy(store.currentItem.accuracy) ? 'error' : ''}
            help={store.currentItem.accuracy && !validateAccuracy(store.currentItem.accuracy) ? 'A precisão deve ser um número positivo' : ''}
          >
            <Input
              value={store.currentItem.accuracy}
              onChange={handleChange.bind(this, 'accuracy')}
              placeholder="25.461"
            />
          </Form.Item>
        </Col>

        <Col {...labelCol}>
          <Form.Item
            label="RSSI"
            validateStatus={store.currentItem.rssi && !validateRssi(store.currentItem.rssi) ? 'error' : ''}
            help={store.currentItem.rssi && !validateRssi(store.currentItem.rssi) ? 'O RSSI deve estar entre -100 e 0 dBm' : ''}
          >
            <Input
              value={store.currentItem.rssi}
              onChange={handleChange.bind(this, 'rssi')}
              placeholder="-69"
            />
          </Form.Item>
        </Col>

        <Col {...labelCol}>
          <Form.Item label="Reg Type">
            <Select
              value={store.currentItem.reg_type}
              onChange={handleSelect.bind(this, 'reg_type')}
              placeholder="Selecione o tipo de registro"
            >
              <Option value="A">Automático</Option>
              <Option value="G">Google</Option>
              <Option value="F">Fixo</Option>
            </Select>
          </Form.Item>
        </Col>

        {store.currentItem.id && (
          <Col {...labelCol}>
            <Form.Item label="Active">
              <Switch onChange={handleSwitchChange.bind(this, 'active')} checked={switchChecked(store.currentItem.active)} />
            </Form.Item>
          </Col>
        )}

      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item label="Request">
            <Input.TextArea
              rows={7}
              value={store.currentItem.request}
              onChange={(e) => {
                const request = e.target.value;
                store.currentItem.request = request;
              }}
              placeholder="Digite a requisição..."
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  ))
}

const BssidList = () => {
  const store = React.useContext(storeContext);

  ContentForm = Form.create({})(ContentForm);

  store.columns = columns;
  store.url = '/bssid';

  store.editForm = undefined;
  ContentForm.tab = 'Info';

  store.tabs = [ContentForm];

  return (
    <div>
      <RegistryForm />
    </div>
  )
}

export default BssidList;